import React from 'react';
import CTABanner from '../components/CTABanner';
import './WhyChooseUsPage.css';

function WhyChooseUsPage() {
  return (
    <div className="why-choose-us-page page-top">
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Commercial Carpet Cleaning Oxon?</h2>
            <p>
              We're a family-run business built on doing the job properly.
              Here's what sets us apart from the rest.
            </p>
          </div>

          <div className="why-grid">
            <div className="why-card card">
              <div className="why-card__icon">&#128104;&#8205;&#128105;&#8205;&#128103;</div>
              <h3>Family-Run Business</h3>
              <p>
                We're not a faceless franchise. You'll deal directly with us — people
                who genuinely care about the quality of every clean.
              </p>
            </div>

            <div className="why-card card">
              <div className="why-card__icon">&#127807;</div>
              <h3>Eco-Friendly Methods</h3>
              <p>
                Our cleaning products are safe for people, pets, and the planet.
                Effective results without harmful chemicals.
              </p>
            </div>

            <div className="why-card card">
              <div className="why-card__icon">&#128336;</div>
              <h3>Flexible Scheduling</h3>
              <p>
                Evenings, overnight, weekends — we work when it suits your business,
                not the other way around.
              </p>
            </div>

            <div className="why-card card">
              <div className="why-card__icon">&#128737;</div>
              <h3>Fully Insured</h3>
              <p>
                Complete peace of mind with comprehensive public liability and
                employer's liability insurance.
              </p>
            </div>

            <div className="why-card card">
              <div className="why-card__icon">&#129309;</div>
              <h3>Honest Pricing</h3>
              <p>
                Clear, upfront quotes with no hidden fees. You'll know exactly
                what you're paying before we start.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About / Team Section */}
      <section className="section section--soft">
        <div className="container">
          <div className="split">
            <div className="split__image">
              <img
                src="/images/team_professional_portrait.jpg"
                alt="Our professional carpet cleaning team in Oxfordshire"
              />
            </div>
            <div className="split__content">
              <h2>Professional Standards, Personal Touch</h2>
              <p>
                We started this business because we saw too many commercial spaces
                being let down by carpet cleaning services that cut corners. Every
                job we take on gets the same care and attention — whether it's a
                single office or an entire hotel.
              </p>
              <p>
                Our team uses professional-grade equipment and eco-friendly products
                to deliver results that last. And because we work around your schedule,
                your business never misses a beat.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Eco-friendly section */}
      <section className="section">
        <div className="container">
          <div className="split split--reverse">
            <div className="split__image">
              <img
                src="/images/eco_friendly_cleaning.jpg"
                alt="Eco-friendly carpet cleaning products and professional technique"
              />
            </div>
            <div className="split__content">
              <h2>Committed to Sustainability</h2>
              <p>
                Every product we use has been chosen for effectiveness and environmental
                responsibility. Our solutions are non-toxic, biodegradable, and safe for
                use around staff, visitors, children, and pets.
              </p>
              <p>
                We believe that delivering an outstanding clean shouldn't come at the
                expense of the environment.
              </p>
            </div>
          </div>
        </div>
      </section>

      <CTABanner
        heading="See the Difference for Yourself"
        description="Book a free, no-obligation survey and we'll show you what we can do for your carpets."
        ctaText="Arrange a Free Survey"
      />
    </div>
  );
}

export default WhyChooseUsPage;
